import React from 'react'

import { ConfirmModal } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool } from 'prop-types'

function DeleteConfirmModal({
  itemType = 'item',
  itemName = '',
  isSubmitDisabled = false,
  onSubmit: handleSubmit,
  onCancel: handleCancel,
}) {
  return (
    <ConfirmModal
      header={`Delete ${itemType}?`}
      submitText="Delete"
      cancelText="Cancel"
      isDangerousAction
      isSubmitDisabled={isSubmitDisabled}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    >
      {itemName
        ? `"${itemName}" will be permanently deleted. This action cannot be undone.`
        : `This ${itemType} will be permanently deleted. This action cannot be undone.`}
    </ConfirmModal>
  )
}

DeleteConfirmModal.propTypes = {
  itemType: string,
  itemName: string,
  isSubmitDisabled: bool,
  onSubmit: func.isRequired,
  onCancel: func.isRequired,
}

export default DeleteConfirmModal
